import { Injectable } from '@angular/core';
import { CustomHttp } from '../../../directives/customhttp';
import { ResponseContentType, Headers, Response } from '@angular/http';
import { Globals } from '../../app.globals';

/*
* Author: Muhammad Danish Khan
* Organization: Vteams Inc.
* Description: Purpose of this file is to provide features related to backend services (api) and make the access easy
*/

@Injectable()
export class API {

    constructor(private http: CustomHttp) {
        http.setBaseUrl(new Globals().apiEndpoint);
        http.prepareForWegetAPI();
        this.handshake();
    }

    post(path: string, params: any) {
        return this.http.post(path, JSON.stringify(params))
            .map((res) => {
                if (res._body.length > 0) {
                    if (this.isJSON(res._body)) {
                        return res.json();
                    } else {
                        return {};
                    }
                } else {
                    return '';
                }
            });
    }


    delete(path: string, options?: any) {
        return this.http.delete(path, options)
            .map((res: any) => {
                if (res._body.length > 0) {
                    if (this.isJSON(res._body)) {
                        return res.json();
                    } else {
                        return {};
                    }
                } else {
                    return '';
                }
            });
    }

    get(path: string) {
        return this.http.get(path)
            .map((res: any) => {
                if (res._body.length > 0) {
                    if (this.isJSON(res._body)) {
                        return res.json();
                    } else {
                        return {};
                    }
                } else {
                    return '';
                }
            });
    }

    download(path: string) {
        return this.http.get(path, { responseType: ResponseContentType.Blob })
            .map((res: any) => {
                let contentDispositionHeader = res.headers.get('Content-Disposition');
                let contentType = res.headers.get('content-type');
                let result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
                let filename = result.replace(/"/g, '');
                let linkElement = document.createElement('a');
                try {
                    // if (res._body.length > 0) {
                    let blob = new Blob([String.fromCharCode(0xFEFF), res._body], { type: contentType });
                    //  window['saveAs'](blob, 'test.mp3');
                    let url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    return false;
                }
                return true;

            });
    }

    handshake() {
        return this.get('api/handshake').subscribe((res) => {
            if (res.tracker) {
                localStorage.setItem('tracker', res.tracker);
            }
            if (res.preferences) {
                res.preferences.forEach((arrayItem) => {
                    if (arrayItem.value === '1') {
                        arrayItem.value = true;
                    }
                    if (arrayItem.value === '') {
                        arrayItem.value = false;
                    }
                });
            }
        });
    }

    list(path: string) {
        return this.http.get(path)
            .map((res: any) => {
                if (res._body.length > 0) {
                    return res.json();
                } else {
                    return '';
                }
            });
    }

    isJSON(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/services/api.service.ts